export default{

    reportAgreement: ({ commit, dispatch }, reportData) => {
        commit('reportAgreement', reportData)
    }
}